import $ from 'jquery'
export default {
    name: 'modal-traite-soins-sans-consultation',
    components: {},
    props: {
        soin: Object,
        heure: String
    },
    data() {
        return {
            user_id: 0,
            loading: false,
            a_traite: ''
        }
    },
    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    mounted() {
        this.user_id = this.userCredentials.id
            // console.log('utilisateur', this.user_id)
    },
    methods: {
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        /**
         * Enregistrer le traitement
         * @param {*} catID 
         */
        traiterSoin() {
            this.loading = true;
            if (!this.a_traite) {
                $('.err-msg').fadeIn(500)
                this.loading = false;
                return;
            }
            let data = {
                medecin: this.user_id,
                soin: this.soin.id
            }
            this.$store.dispatch("updateSoinSansConsultation", data).then((response) => {
                console.log('updated', response)
                this.$emit('rafraichir')
                this.doSuccessMsg('Le traitement du soin a été bien enregistré ')
                this.loading = false;
                this.$refs.close_modal.click();
            })
        },

        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'x',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function(msg) {
            let to_print = "Echec";
            if (msg)
                to_print = msg

            if (this.$toasted != null) this.$toasted.clear()

            this.$toasted.show(to_print, {
                action: [{
                    text: 'x',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },
    }
}